import type { ButtonHTMLAttributes, ReactNode } from "react";

export type Tone = "default" | "primary" | "success" | "warning" | "danger" | "info";

/** 实心按钮的底色；default 走描边白底 */
const SOLID: Record<Exclude<Tone, "default">, string> = {
  primary: "bg-primary hover:bg-primary-700",
  success: "bg-success hover:bg-success-700",
  warning: "bg-warning hover:bg-warning-700",
  danger: "bg-danger hover:bg-danger-700",
  info: "bg-info hover:bg-info-700",
};

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: Tone;
  size?: "sm" | "md";
  children: ReactNode;
}

export function Button({ tone = "default", size = "md", type = "button", className = "", disabled, children, ...rest }: Props) {
  const base =
    "inline-flex items-center justify-center gap-1 rounded-base font-medium whitespace-nowrap transition-colors " +
    (size === "sm" ? "h-control-sm px-2.5 text-xs" : "h-control px-4 text-base");
  const skin = disabled
    ? "bg-fill-light text-ink-disabled border border-line cursor-not-allowed"
    : tone === "default"
      ? "bg-white text-ink-regular border border-line hover:border-primary hover:text-primary"
      : `${SOLID[tone]} text-white border-none`;
  return (
    <button type={type} disabled={disabled} className={`${base} ${skin} ${className}`} {...rest}>
      {children}
    </button>
  );
}
